import { createFileRoute } from '@tanstack/react-router'
import { SettingsGovernedTools } from '@/features/settings/governed-tools'

type GovernedToolsSearch = {
  instanceId?: number
  toolId?: number
  tab?: 'overview' | 'assignments' | 'approvals' | 'audit'
}

export const Route = createFileRoute('/_authenticated/automation/governed-tools')({
  validateSearch: (search: Record<string, unknown>): GovernedToolsSearch => {
    const rawInstanceId =
      search.instanceId !== undefined && search.instanceId !== null
        ? Number(search.instanceId)
        : undefined
    const rawToolId =
      search.toolId !== undefined && search.toolId !== null ? Number(search.toolId) : undefined
    return {
      instanceId:
        typeof rawInstanceId === 'number' && Number.isFinite(rawInstanceId)
          ? rawInstanceId
          : undefined,
      toolId: typeof rawToolId === 'number' && Number.isFinite(rawToolId) ? rawToolId : undefined,
      tab:
        search.tab === 'overview' ||
        search.tab === 'assignments' ||
        search.tab === 'approvals' ||
        search.tab === 'audit'
          ? search.tab
          : undefined,
    }
  },
  component: SettingsGovernedTools,
})
